export default "{\n    \"servicedByText\": \"Atendido por {{servicePartner}}\"\n}\n"